import { fetchCampaigns } from "../apis/admin";

export async function loadAdminCampaignsPageData({ request }) {
    const url = new URL(request.url)
    const orgID = url.searchParams.get('orgID')
    const { error, campaigns } = await fetchCampaigns({ orgID });
    if (error) {
        throw new Error(error);
    }

    return { campaigns };
}
